import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as accountsDashboardAPI from '../../api/AccountsAPI/accountsDashboardAPI';

export const fetchCCCashBalanceSummary = createAsyncThunk(
    'accountsDashboard/fetchCCCashBalanceSummary',
    async ({ roleId, userId } = {}, { rejectWithValue }) => {
        try {
            const response = await accountsDashboardAPI.getCCCashBalanceSummary({ roleId, userId });
            return response?.Data || response;
        } catch (error) {
            return rejectWithValue(error.message || 'Failed to fetch CC Cash Balance Summary');
        }
    }
);

export const fetchAccountsDashboardSummary = createAsyncThunk(
    'accountsDashboard/fetchAccountsDashboardSummary',
    async ({ roleId, userId } = {}, { rejectWithValue }) => {
        try {
            const response = await accountsDashboardAPI.getAccountsDashboardSummary({ roleId, userId });
            return response?.Data || null;
        } catch (error) {
            return rejectWithValue(error.message || 'Failed to fetch Accounts Dashboard Summary');
        }
    }
);

const initialState = {
    ccCashBalances: [],
    loading: false,
    error: null,
    summary: null,
    summaryLoading: false,
    summaryError: null,
};

const accountsDashboardSlice = createSlice({
    name: 'accountsDashboard',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCCCashBalanceSummary.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCCCashBalanceSummary.fulfilled, (state, action) => {
                state.loading = false;
                state.ccCashBalances = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(fetchCCCashBalanceSummary.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchAccountsDashboardSummary.pending, (state) => {
                state.summaryLoading = true;
                state.summaryError = null;
            })
            .addCase(fetchAccountsDashboardSummary.fulfilled, (state, action) => {
                state.summaryLoading = false;
                state.summary = action.payload;
            })
            .addCase(fetchAccountsDashboardSummary.rejected, (state, action) => {
                state.summaryLoading = false;
                state.summaryError = action.payload;
            });
    },
});

export const selectCCCashBalances = (state) => state.accountsDashboard.ccCashBalances;
export const selectAccountsDashboardLoading = (state) => state.accountsDashboard.loading;
export const selectAccountsDashboardSummary = (state) => state.accountsDashboard.summary;
export const selectAccountsDashboardSummaryLoading = (state) => state.accountsDashboard.summaryLoading;

export default accountsDashboardSlice.reducer;
